import { useEffect, useMemo } from 'react';

import { Article } from '@zooplus/checkout-state';

import { useMobileApp } from '@hooks/use-mobile-app';

export const useMobileBasketCount = (articles: Article[]) => {
  const isMobileApp = useMobileApp();

  const basketCount = useMemo(() => {
    if (!isMobileApp) {
      return 0;
    }
    return articles.reduce((total, item) => total + (item.quantity || 0), 0);
  }, [isMobileApp, articles]);

  useEffect(() => {
    if (isMobileApp && window.zooplusApp) {
      window.zooplusApp.updateUserData(JSON.stringify({ basketCount }));
    }
  }, [basketCount, isMobileApp]);
};
